/**
 * Target company info selector.
 *
 * @param {object} state Store state.
 * @returns {Immutable.Map} Target company info.
 */
export const companyInfo = state => state.targetCompany.target;
